import type { SVGProps } from "react";
export default function SvgChartPie(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-chart-pie-icon lucide-chart-pie"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z" />
			<path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
		</svg>
	);
}
